export const headerStyle = {
    fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFADD8E6' } },
    font: { bold: true },
    alignment: { vertical: 'middle', horizontal: 'center' },
    border: {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
    },
};


export const subtotalStyle = {
        font: { bold: true, color: { argb: 'FFFFFF' } },
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: '5a6c8c' } },
        alignment: { vertical: 'middle', horizontal: 'right' },
        border: {
            top: { style: 'thin' }, bottom: { style: 'thin' },
            // left: { style: 'thin' }, right: { style: 'thin' }
        }
    };
 export const totalStyle = {
    font: { bold: true,},
    fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFC6EFCE' } },
    alignment: { vertical: 'middle', horizontal: 'right' },
    border: {
        top: { style: 'thin' }, bottom: { style: 'thin' },
        // left: { style: 'thin' }, right: { style: 'thin' }
    }
  };

export const dataCellStyle = {
    fill: { type: 'pattern', pattern: 'solid' },
    font: { bold: false },
    alignment: { vertical: 'middle', horizontal: 'center' },
    border: {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
    },
}
